import { getAuthToken } from '@/shared/lib/storage'
import http from '../../api/http'
import type { ApiResponse } from '../../api/http/api/response.api'
import httpBare from '../../api/http/bare'
import type {
  AuthResponse,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  LoginRequest,
  OtpRequestPayload,
  OtpVerifyPayload,
  SetPasswordRequest,
  UserProfile,
  VerifyPasswordTokenResponse,
} from './components/authservice.param'
import * as urls from './components/urls'

const login = (payload: LoginRequest): Promise<ApiResponse<AuthResponse>> =>
  http.post(urls.apiLogin, payload)

// OTP: dùng httpBare để 401/400 của verify không rơi vào vòng refresh và không bị toast lỗi riêng.
const requestOtp = async (
  payload: OtpRequestPayload,
  turnstileToken?: string
): Promise<ApiResponse> => {
  const res = await httpBare.post(
    urls.apiOtpRequest,
    payload,
    turnstileToken ? { headers: { 'X-Turnstile-Token': turnstileToken } } : undefined
  )
  return res.data
}

const verifyOtp = async (payload: OtpVerifyPayload): Promise<ApiResponse<AuthResponse>> => {
  const res = await httpBare.post(urls.apiOtpVerify, payload)
  return res.data
}

const getMe = (): Promise<ApiResponse<UserProfile>> => http.get(urls.apiGetMe)

// Dùng httpBare (không interceptor) để refresh không tự xếp mình vào vòng 401.
const refreshToken = async (refreshTokenValue?: string): Promise<ApiResponse<AuthResponse>> => {
  const res = await httpBare.post(
    urls.apiRefreshToken,
    refreshTokenValue ? { refreshToken: refreshTokenValue } : {},
    { headers: { Authorization: `Bearer ${getAuthToken() ?? ''}` } }
  )
  return res.data
}

const logout = (): Promise<ApiResponse> => http.post(urls.apiLogout)

const forgotPassword = (payload: ForgotPasswordRequest): Promise<ApiResponse<string>> =>
  http.post(urls.apiForgotPassword, payload)

const verifyPasswordToken = (token: string): Promise<ApiResponse<VerifyPasswordTokenResponse>> =>
  http.get(`${urls.apiVerifyPasswordToken}?token=${encodeURIComponent(token)}`, {
    skipGlobalError: true,
  })

const setPassword = (payload: SetPasswordRequest): Promise<ApiResponse<string>> =>
  http.post(urls.apiSetPassword, payload, { skipGlobalError: true })

const changePassword = (payload: ChangePasswordRequest): Promise<ApiResponse> =>
  http.post(urls.apiChangePassword, payload)

const AuthService = {
  login,
  requestOtp,
  verifyOtp,
  getMe,
  refreshToken,
  logout,
  forgotPassword,
  verifyPasswordToken,
  setPassword,
  changePassword,
}
export default AuthService
